import { createSlider, getObserver } from '@theme/theme-global';
class CollectionPanelsSlider extends HTMLDivElement {
  constructor() {
    super();
    this.section = this.closest('.shopify-section');
    this.sliderInstance = null;
    this._observer = null;
  }

  connectedCallback() {
    if (!this.sliderInstance) {
      this.init();
    }
  }

  init() {
    const isFirstSection = this.section && this.section.querySelector('[data-index]').dataset.index === '1';
    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    if (isFirstSection) {
      if (isMobile && typeof window.skyAfterLCP === 'function') {
        window.skyAfterLCP(() => {
          createSlider(this, JSON.parse(this.dataset.params)).then((instance) => {
            this.sliderInstance = instance;
          });
        });
      } else {
        createSlider(this, JSON.parse(this.dataset.params)).then((instance) => {
          this.sliderInstance = instance;
        });
      }
    } else if ('IntersectionObserver' in window) {
      this._observer = getObserver({ rootMargin: '300px 0px', threshold: 0 }, true, false);
      this._observer.observe(this, () => {
        const initCollectionPanelsSlider = () => {
          if (this.sliderInstance || this._sliderInitializing) return;
          this._sliderInitializing = true;
          createSlider(this, JSON.parse(this.dataset.params))
            .then((instance) => {
              this.sliderInstance = instance;
            })
            .finally(() => {
              this._sliderInitializing = false;
            });
        };

        const run = () => {
          if ('requestIdleCallback' in window) {
            requestIdleCallback(initCollectionPanelsSlider);
          } else {
            requestAnimationFrame(() => {
              setTimeout(initCollectionPanelsSlider, 0);
            });
          }
        };

        if (isMobile && typeof window.skyAfterLCP === 'function') {
          window.skyAfterLCP(run);
        } else {
          run();
        }
      });
    } else {
      createSlider(this, JSON.parse(this.dataset.params)).then((instance) => {
        this.sliderInstance = instance;
      });
    }
  }

  disconnectedCallback() {

    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
    if (this.sliderInstance) {
      this.sliderInstance.destroy();
      this.sliderInstance = null;
    }

  }
}
if (!customElements.get('collection-panels-slider')) {
  customElements.define('collection-panels-slider', CollectionPanelsSlider, { extends: 'div' });
}